import Rails from 'rails-ujs';
import { Controller } from 'stimulus';

export default class extends Controller {

  static targets = ['filePreview', 'photo', 'removeCheckbox'];

  fileChanged(event) {
    const target = event.currentTarget;
    const file = target.files[0];
    if (this.isValid(file)) {
      const preview = this.filePreviewTarget;
      this.handleFile(file, preview);
      if (this.hasRemoveCheckboxTarget) {
        this.removeCheckboxTarget.checked = false;
      }
    }
  }

  handleFile(file, preview) {
    preview.innerHTML = '';

    // 画像
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = document.createElement('img');
        img.classList.add('preview');
        img.src = e.target.result;
        preview.appendChild(img);
      };
      reader.readAsDataURL(file);
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.classList.add('file-preview');

    const icon = document.createElement('i');

    if (file.type === 'application/pdf') {
      // ドキュメント
      icon.className = 'fas fa-file-pdf';
    } else if (
      file.type === 'application-zip'
      || file.type === 'application/x-zip-compressed'
    ) {
      // 圧縮ファイル
      icon.className = 'fas fa-file-archive';
    } else {
      icon.className = 'fas fa-file';
    }

    const info = document.createElement('div');
    info.classList.add('file-preview__info');

    const name = document.createElement('div');
    name.classList.add('file-preview__name');
    name.textContent = file.name;

    const size = document.createElement('div');
    size.classList.add('file-preview__size');
    size.textContent = this.formatFileSize(file.size);

    info.appendChild(name);
    info.appendChild(size);

    wrapper.appendChild(icon);
    wrapper.appendChild(info);

    preview.appendChild(wrapper);
  }

  isValid(file) {
    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf', 'application/zip', 'application/x-zip-compressed'];
    if (!file) {
      return false;
    }
    if (!allowedTypes.includes(file.type)) {
      alert('画像ファイル (jpg, png)、ドキュメントファイル (pdf)、または圧縮ファイル（zip）のみアップロードすることができます。');
      return false;
    }
    if (file.size > 10 * 1024 * 1024) {
      alert('ファイルサイズは最大10MBです');
      return false;
    }
    return true;
  }

  destroyPhoto() {
    const preview = this.filePreviewTarget;
    preview.innerHTML = '<i class="fas fa-image"></i>';
    this.photoTarget.value = '';
  }

  formatFileSize(bytes) {
    if (bytes < 1024) return `${bytes}B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)}KB`;
    return `${(bytes / 1024 / 1024).toFixed(1)}MB`;
  }
}
